import { Table, TablePagination } from "@mui/material";
import { styled } from '@mui/styles';

export const StyledTable = styled(Table)(({ theme })=>({
    '& .MuiTableHead-root p': {
        fontWeight: 600, 
        fontSize: '13px'
    },
    '& .MuiTableCell-root': {
        padding: '10px 10px 10px 0',
        maxWidth: '100px'
    }
}));

export const StyledPagination = styled(TablePagination)(({ theme })=>({
    borderBottom: 'none !important',
    '& p': {
        marginBottom: 0
    },
    [theme.breakpoints.down('sm')]: {
        '& .MuiTablePagination-selectLabel, .MuiInputBase-root': {
            display: 'none'
        }
    },
}));